import type {Editor} from "slate";

/**
 * Checks if Khanmigo is actively editing the given editor.
 */
export const isKhanmigoEditing = (editor: Editor): boolean => {
    return khanmigoEditStartKey in editor;
};
export const khanmigoEditStartKey: symbol = Symbol.for("khanmigoEditingKey");
